export default function Services() {
  const services = [
    {
      title: 'Routine Janitorial Services',
      label: 'DAILY SERVICE',
      image: 'https://public.readdy.ai/ai/img_res/e25867ff61bdd54bc4fb62829e98024b.jpg',
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      labelColor: 'bg-teal-100 text-teal-800',
      bullets: [
        'Daily trash removal & liner replacement',
        'Restroom sanitization & restocking',
        'Vacuuming, sweeping & mopping',
        'Surface dusting & disinfecting',
        'Break room & kitchen cleaning',
        'Glass & entrance door polishing',
      ]
    },
    {
      title: 'Professional Floor Care',
      label: 'SPECIALIZED',
      image: 'https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/3035829b5cb63c4e1405e80ced3e1e8e.webp',
      bgColor: 'bg-gray-900',
      textColor: 'text-white',
      labelColor: 'bg-teal-400 text-gray-900',
      bulletColor: 'text-gray-300',
      bullets: [
        'Strip, wax & high-speed buffing',
        'Marble & stone polishing & sealing',
        'Carpet deep extraction cleaning',
        'Grout cleaning & tile restoration',
        'Anti-slip coating application',
        'Hardwood refinishing & conditioning',
      ]
    },
    {
      title: 'Industry Specific Cleaning',
      label: 'CERTIFIED',
      image: 'https://static.readdy.ai/image/afaf0eabbceea583753f6e045d53514c/03f73ced0055ad55b227e31e0ede3213.png',
      bgColor: 'bg-white',
      textColor: 'text-gray-900',
      labelColor: 'bg-teal-100 text-teal-800',
      bullets: [
        'Medical & healthcare facility cleaning',
        'Restaurant & food service sanitation',
        'Parking garage & structure cleaning',
        'Warehouse & industrial floor care',
        'Post-construction cleanup',
        'Compliance-ready documentation',
      ]
    }
  ];

  const propertyTypes = [
    {
      icon: 'ri-building-2-line',
      title: 'Office',
      description: 'Professional environments where first impressions matter — from lobbies to conference rooms.',
    },
    {
      icon: 'ri-store-2-line',
      title: 'Restaurant',
      description: 'Health-code compliant cleaning for kitchens, dining areas, and attractive high-traffic front-of-house spaces.',
    },
    {
      icon: 'ri-shopping-bag-3-line',
      title: 'Retail',
      description: 'Spotless storefronts and sales floors that keep customers comfortable and coming back.',
    },
    {
      icon: 'ri-truck-line',
      title: 'Industrial',
      description: 'Heavy-duty cleaning for warehouses, manufacturing floors, and large commercial facilities.',
    },
  ];

  return (
    <section id="services" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between items-start mb-16">
          <div className="mb-6 md:mb-0">
            <h2 className="text-5xl font-light text-gray-400 mb-1">Our</h2>
            <h3 className="text-6xl font-serif italic text-gray-900">Services</h3>
          </div>
          <div className="md:w-2/5">
            <p className="text-gray-600 text-base leading-relaxed">
              We provide comprehensive commercial cleaning solutions tailored to your business needs. 
              From daily office maintenance to specialized floor care and certified sanitization, 
              our expert team ensures your workspace remains pristine and professional.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`${service.bgColor} rounded-3xl p-6 transition-transform hover:scale-105 cursor-pointer flex flex-col`}
            >
              {service.image && (
                <div className="mb-6 rounded-2xl overflow-hidden h-64 w-full">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              )}
              <span className={`inline-block ${service.labelColor} px-4 py-1.5 rounded-full text-xs font-semibold mb-4`}>
                {service.label}
              </span>
              <h4 className={`text-2xl font-bold ${service.textColor} leading-tight mb-5`}>
                {service.title}
              </h4>
              <ul className="flex flex-col gap-2 mt-auto">
                {service.bullets.map((bullet, bIndex) => (
                  <li key={bIndex} className={`flex items-start gap-2 text-sm ${service.bulletColor ?? 'text-gray-600'}`}>
                    <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-teal-500 shrink-0"></span>
                    {bullet}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-20">
          <h3 className="text-2xl font-bold text-gray-900 mb-3 text-center">Serving the Properties That Drive Silicon Valley</h3>
          <p className="text-gray-500 text-sm text-center max-w-xl mx-auto mb-10">
            We specialize in four property types — each with its own cleaning demands, and each handled with the same high standard.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {propertyTypes.map((type, index) => (
              <div key={index} className="bg-gray-50 rounded-2xl p-6 flex flex-col items-center text-center hover:shadow-md transition-shadow">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-full mb-4">
                  <i className={`${type.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-base font-bold text-gray-900 mb-2">{type.title}</h4>
                <p className="text-xs text-gray-500 leading-relaxed">{type.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
